import { get , post ,post2,get3,post3} from './api';
// 用户注册
export const userControl = {
}
export const zxtj = {
	// 思想引领列表
	zxtjList:(data) => post("?c=d_jds_index&m=jpdkList",data),
}
//红色全景
export const api = {
	// 新闻详情
	newsDetail:(data) => post("?c=d_three_api&m=newsDetail",data),
	// 培训课程
	arList:() => post("?c=d_index&m=ar_list"),
	// 党建宣传
	organProfile:(data) => post('?c=d_three_api&m=organProfile', data),
	// 党员画像
	memberProfile:(data) => post('?c=d_three_api&m=memberProfile', data),
	// 党建宣传 党群共建
	buildList:(data) => post('?c=d_three_api&m=buildList', data),
	// 党建宣传 风采展示
	thearList:(data) => post('?c=d_three_api&m=thearList', data),
	// 党建宣传 风采展示详情
	thearDetail:(data) => post('?c=d_three_api&m=thearDetail', data),
	// 党建宣传 党建要闻更多
	newsMore:(data) => post('?c=d_three_api&m=newsMore', data),
	// 党建宣传 党建公开
	partysMore:(data) => post('?c=d_three_api&m=partysMore', data),
	// 党建宣传 党群共建详情
	selectBuild:(data) => post('?c=d_three_api&m=selectBuild', data),
	// 党建宣传 会议记录更多
	activityMore:(data) => post('?c=d_three_api&m=activityMore', data),
	// 党建宣传 党群共建详情
	partysDetail:(data) => post('?c=d_three_api&m=partysDetail', data),
	// 党建宣传 获取支部列表
	partyOrgan:(data) => post('?c=d_three_api&m=partyOrgan', data),
	// 三会一课详情
	// activityDetail:(data) => post('?c=d_three_api&m=activityDetail', data),
		// 三会一课详情
		activityDetail:(data) => post("?c=d_jds_index&m=shykDetail",data),
}
// 二十大专题
export const rsd = {
	// 首页资源
	homelist:() => post("?c=d_jds_index&m=twienty"),
	// 思想引领列表
	sxylList:(data) => post("?c=d_jds_index&m=sxykMoreJson",data),
	// 思想引领详情
	sxylDetail:(data) => post("?c=d_two_api&m=resouceDetail",data),
   // 学习解读分类
   studyClass:() => post("?c=d_jds_index&m=studyClass"),
	// 学习解读列表
	xxjdList:(data) => post("?c=d_jds_index&m=studyMoreJson",data),
	// 图解海报列表
	tjhbList:(data) => post("?c=d_jds_index&m=tjhbMoreJson",data),
	// 图解海报详情
	tjhbDetail:(data) => post("?c=d_jds_index&m=tjhbMoreJson",data),
	//非凡十年分类
	tenyearClass:() => post("?c=d_jds_index&m=tenYearClass"),
    // 非凡十年列表
	tenyearList:(data) => post("?c=d_jds_index&m=tenYearsMoreJson",data),
}
//首页
export const shouye = {
	// 首页资源
	homelist:() => get("?c=d_jds_index&m=index"),
	// 习思想专题列表
	xsx2Class:(data) => post("?c=d_jds_index&m=xsx2Class",data),
	// 习思想数据列表
	xsx2Json:(data) => post("?c=d_jds_index&m=xsx2Json",data),
	// 红色山西数据列表
	hssxList:(data) => post("?c=d_jds_index&m=hssx",data),
    // 红色山西详情
	hssxDetail:(data) => post("?c=d_jds_index&m=hssxDetail",data),
	// 省份分类
	provinceList: (data) => get("?c=d_jds_index&m=provinceList", data),
	// 红色云展厅列表
	hsyztList: (data) => post("?c=d_jds_index&m=hsyztList", data),
	// 红色云展厅详情
	hsyztDetail: (data) => post("?c=d_jds_index&m=hsyztDetail", data),
}
// 新闻中心
export  const  news = {
		// 精品党课分类
		jpdkClass: (data) => post("?c=d_jds_index&m=jpdkClass", data),
		// 精品党课分类
		jpdkList: (data) => post("?c=d_jds_index&m=jpdkList", data),
	// 新闻更多
	newsMore:(data) => post("?c=d_index&m=newsMore",data),
	// 新闻详情
	newsDetail:(data) => post("?c=d_jds_index&m=newDetail",data),
	// 教师详情
	teacherDetail:(data) => post("?c=d_index&m=userInfo",data),
	// 搜索结果
	searchList:(data) => post("?c=d_index&m=searchList",data),
	// 新闻列表
	newshList:(data) => post("?c=d_jds_index&m=newsList",data),
	// 党建共建分类
	djgjClassList:() => post("?c=d_jds_index&m=djgjClass"),
	// 党建共建列表
	djgjList:(data) => post("?c=d_jds_index&m=djgjList",data),
	// 党建共建详情
	djgjDetail:(data) => post("?c=d_jds_index&m=djgjDetail",data),
	// 图解党建列表
	getTjdjList:(data) => post("?c=d_jds_index&m=tjdjList",data),
	// 通知公告列表
	getTzggList:(data) => post("?c=d_jds_index&m=tzggList",data),
	// 通知公告详情
	TzggDetail:(data) => post("?c=d_jds_index&m=tzggDetail",data),
	// 政策解读
	getZcjdList:(data) => post("?c=d_jds_index&m=zcjdList",data),
	// 政策解读详情
	getZcjdDetail:(data) => post("?c=d_jds_index&m=zcjdDetail",data),
	// 图解党建详情
	tjdjDetail:(data) => post("?c=d_jds_index&m=tjdjDetail",data),
	// 时间
	tssztime:(data) => post("?c=d_jds_index&m=tsszYear",data),
	// 图说时政列表
	tsszList:(data) => post("?c=d_jds_index&m=tsszList",data),
	// 党务公开列表
	dwgkList:(data) => post("?c=d_jds_index&m=dwgkList",data),
	// 党务公开详情
	dwgkDetail:(data) => post("?c=d_jds_index&m=dwgkDetail",data),
	// 党建学习标题列表
	djxxClass:() => post("?c=d_jds_index&m=djxxClass"),
	// 党建学习二级类
	TwoClassList:(data) => post("?c=d_jds_index&m=djxxTwoList",data),
	// 党建学习内容列表
	djxxdataList:(data) => post("?c=d_jds_index&m=djxxList",data),
	// 党建学习资源播放
	resouceDetail:(data) => post("?c=d_jds_index&m=resouceDetail",data),
	// 院校专栏列表
	getYxzlList:(data) => post("?c=d_jds_index&m=yxzlList",data),
	// 删除文件接口
	delfile:(data) => post2('',data),
	// 院校专栏分类
	getYxzlClass:() => post("?c=d_jds_index&m=yxzlClass"),
	// 党建百科分类
	djbkClass:() => post("?c=d_jds_index&m=djbkClass"),
	// 党建百科列表
	djbkList:(data) => post("?c=d_jds_index&m=djbkList",data),

}

// 首页
export const user = {
	// 用户信息
	userinfo:(data) => get("?c=d_jds_index&m=updateInfo",data),
	// 更新信息
	updateUserinfo:(data) => post("?c=d_jds_index&m=updateInfo",data),
	// 获取民族列表
	getNationList:() => post("?c=d_jds_index&m=nation"),
	// 登录
	loginUsers:(data) => post("?c=login&m=loginUsers",data),
	// 个人中心首页
	infoIndex:(data) => post("?c=d_jds_index&m=infoIndex",data),
	// 个人中心顶部数据
	infoUpData:(data) => post("?c=d_jds_index&m=infoUpData",data),
	// 个人学习数据数据
	collectList:(data) => post("?c=d_jds_index&m=collectList",data),
	// 个人收藏浏览
	clickCollect:(data) => post("?c=d_jds_index&m=clickCollect",data),
	// 资源下载
	downResouce:(data) => post("?c=d_jds_index&m=downResouce",data),
    // 三会一课
	infoShykList:(data) => post("?c=d_jds_index&m=infoShykList",data),
	 // 在线考试列表
	 ExamList:(data) => post("?c=d_jds_index&m=onlineTest",data),
	 // 在线考试列表
	 ExamDetail:(data) => post("?c=d_jds_index&m=questionList",data),
	 // 提交试卷
	makeTest:(data) => post("?c=d_jds_index&m=makeTest",data),
	//个人中心培训任务列表
     tranList:(data) => post("?c=d_jds_index&m=infoTrainTaskList",data),
	//  修改密码
	updatePwd:(data) => post("?c=d_jds_index&m=updatePwd",data),
	//个人中心工作任务列表
	WorkList:(data) => post("?c=d_jds_index&m=infoWorkList",data),
	// 工作任务详情
	updateWork:(data) => get("?c=d_jds_index&m=updateWork",data),
	// 工作任务详情
	updateWork2:(data) => post("?c=d_jds_index&m=updateWork",data),

}
//组织生活
export const zzsh = {
	// 三会一课列表
	shykList:(data) => post("?c=d_jds_index&m=shykList",data),
	// 三会一课详情
	shykDetail:(data) => post("?c=d_jds_index&m=shykDetail",data),
	// 小程序二维码
	getWxcode:(data) => post("?c=d_jds_index&m=getWxcode",data),
	// app二维码
	getAppCode:(data) => post("?c=d_jds_index&m=getAppCode",data),
	// 会议签到记录
	signLog:(data) => post("?c=d_jds_index&m=signLog",data),
	//新增学习心得
	addRecord:(data) => post("?c=d_jds_index&m=addRecord",data),
}
//组织生活
export const ztpx = {
	//专题培训列表
	ztpxList:(data) => post("?c=d_jds_index&m=trainTaskList",data),
	// 培训任务详情
	trainTaskDetail:(data) => post("?c=d_jds_index&m=trainTaskDetail",data),
	// 新增学习心得
	addExperience:(data) => post("?c=d_jds_index&m=addExperience",data),
	// 搜索列表
	searchDataList:(data) => post("?c=d_jds_index&m=searchList",data),

}







